import '.ce{position:relative;}.ssr-plugin'
import '.i7{width:64px;}.ssr-plugin'
import '.i8{height:64px;}.ssr-plugin'
import '.ay{flex-shrink:0;}.ssr-plugin'
import '.j{position:absolute;}.ssr-plugin'
import '.i9{bottom:-4px;}.ssr-plugin'
import '.e0{right:-4px;}.ssr-plugin'
import '.eo{border-radius:50%;}.ssr-plugin'
import '.ia{border:2px solid var(--shades-white);}.ssr-plugin'
import '.n{overflow:hidden;}.ssr-plugin'
import '.ib{width:32px;}.ssr-plugin'
import '.ic{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { resizeImage } from '@app/util/helpers'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ce i7 i8 ay"
    >
      {initiativeImage ? (
        <Image
          src={resizeImage(initiativeImage, 128)}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="j i9 e0 eo ia n ib ic"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
